<template>
  <div style="height: 100%">
    <div id="allmap" ref="allmap"></div>
  </div>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import loadBMap from '@/utils/baiduMap.js' //单个文件加载百度地图
export default {
  name: "cpt-display-trail",
  props: {
    option: Object,
    refMap: Object,
    current: Object,
  },
  inject: ['showContextMenu'],
  data() {
    return {
      cptData: [],
      newData: [],
      jsFunFlag: false,
      uuid: null,
      bmap: null,
    };
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "option.attribute": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
        this.initMap();
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  async mounted() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.$route.name != "design") {
      var element_two = document.getElementById("allmap");
      element_two.style.transform = "scaleX(1.2) scaleY(1.2)";
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
    // this.refreshCptData();
      if (!this.option.attribute.hasOwnProperty('trackAni')) {
        this.option.attribute.trackAni = false;
     }
     await this.loadBaiduMap();
      this.initMap();
  },
  created(){

  },
  methods: {

    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
        
        // setTimeout(() => {
        //   this.initMap();
        // }, 700);
      });
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if (
          this.current.cptOption.interaction.fatherGridId &&
          isFromGrid != "ninegrid"
        )
          return;

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            console.log("res接口返回数据", res);
            let newarr = this.transformArray(
              res,
              this.option.attribute.cptTableData
            );
            console.log("newarr映射后的数据", newarr);
            this.cptData = newarr;
          }
        } else {
          // 如果配置了转换脚本
          this.cptData = res;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.cptData = res;
      }
    },
    transformArray(data, mapping) {
      return data.map((item) => {
        let newItem = {};
        for (const map of mapping) {
          console.log("map", map);
          newItem[map.namekey] = item[map.value];
        }
        // 添加 'url' 字段，并设置为空字符串
        // newItem.url = "";
        return newItem;
      });
    },
    initMap() {
      let centerx = this.option.attribute.centerx;
      let centery = this.option.attribute.centery;
      let zoom = this.option.attribute.zoom;
      // GL版命名空间为BMapGL
      // 按住鼠标右键，修改倾斜角和角度
            const mapContainer = this.$refs.allmap;
      this.bmap = new BMapGL.Map(mapContainer); // 创建Map实例
      this.bmap.addEventListener("rightclick", (e) => {
        // 这里边写加载完成之后的执行操作
        e.clientY = e.clientPos.y;
        e.clientX = e.clientPos.x;
        this.showContextMenu(e)
      });
      // console.log(this.bmap,'this.bmap')
      this.bmap.centerAndZoom(new BMapGL.Point(centerx, centery), zoom); // 初始化地图,设置中心点坐标和地图级别
      this.bmap.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      var path = this.cptData; // 线的数据
      var point = [];
      for (var i = 0; i < path.length; i++) {
        point.push(new BMapGL.Point(path[i].LNG, path[i].LAT));
      }
      // 起点图标
      let myIconStart = new BMapGL.Icon(
        require("@/assets/start.png"),
        new BMapGL.Size(23, 25)
      );
      let markerStart = new BMapGL.Marker(point[0], { icon: myIconStart });
      this.bmap.addOverlay(markerStart);
      // 结束图标
      let myIconEnd = new BMapGL.Icon(
        require("@/assets/end.png"),
        new BMapGL.Size(23, 25)
      );
      let markerEnd = new BMapGL.Marker(point[point.length - 1], {
        icon: myIconEnd,
      });
      this.bmap.addOverlay(markerEnd);
      var pl = new BMapGL.Polyline(point, {
        strokeColor: this.option.attribute.strokeColor, // 设置轨迹线颜色
        strokeWeight: this.option.attribute.strokeWeight, // 设置轨迹线宽度
        strokeStyle: this.option.attribute.strokeStyle, // solid或dashed
      });
    console.log(this.option.attribute.trackAni,'/')
      if(this.option.attribute.trackAni) {
                var trackAni = new BMapGLLib.TrackAnimation(this.bmap, pl, {
        overallView: true,
        tilt: 30,
        duration: this.option.attribute.duration, //20000
        delay: 300,
      });
      trackAni.start();
      } else {
             this.bmap.addOverlay(pl);
      }
    },
     async loadBaiduMap() {
      await loadBMap('',true); //因为有轨迹动画，需要加载两个文件 
    },
  },
};
</script>

<style scoped>
body,
html,
#allmap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  font-family: "微软雅黑";
}
</style>